import api from "./client";

// Internal to-dos from calls (Aircall), meetings (Fireflies) and client/supplier
// email (email task agent). Backend: routes/tasks.py.
export const getTasks = (params) => api.get("/tasks", { params });
export const getTask = (taskId) => api.get(`/tasks/${taskId}`);
export const getTaskAssignees = () => api.get("/tasks/assignees");
export const updateTask = (taskId, data) => api.patch(`/tasks/${taskId}`, data);
